import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import * as DatabaseCaseCreationActions from './action';
import {CORE_API} from '../../../config';

export function* databaseCaseCreationFunc(action) {
    let requestUrl = `${CORE_API}/case/createDatabaseReport/${action.data}`;
    try {
        const result = yield call(request, requestUrl, {method: 'POST', headers: HTTP_HEADERS });
        yield put(DatabaseCaseCreationActions.databaseCaseCreationSuccess(result));
    } catch (err) {
        yield put(DatabaseCaseCreationActions.databaseCaseCreationFailure(err))
    }
}

export function* databaseCaseCreation() {
    yield takeLatest(DatabaseCaseCreationActions.DATABASE_CASE_CREATION, databaseCaseCreationFunc);
}